import React from "react";
import { Link } from "react-router-dom";
import CTAButton from "../CTAButton/CTAButton";
import TestimonialSlider from "../TestimonialSlider/TestimonialSlider";
import "./Company.css";
import aiFallback from "../../assets/ai-section-fallback.png";

const Company = () => {
  return (
    <div className="company-page">
      <section className="company-hero">
        <div className="hero-left">
          <Link to="/features" className="back-link">Back to features</Link>
          <h1>You're in good company</h1>
          <p>
            Join the thousands of organizations using Mailsnappy to save money on their email marketing.
          </p>
          <div className="hero-form"><CTAButton>Get started</CTAButton></div>
        </div>
        <div className="hero-right">
          <img src={aiFallback} alt="User" />
        </div>
      </section>

      <section className="company-showcase">
        <div className="company-row">
          <img src={aiFallback} alt="Folksy" />
          <div className="text">
            <h2>Folksy uses Mailsnappy to send eye-catching emails to customers of Britain's best designers and makers</h2>
          </div>
        </div>

        <div className="company-grid">
          <div className="company-card">
            <img src={aiFallback} alt="Popbitch" />
            <p>Weekly celebrity newsletter Popbitch found flexibility, support, and lower costs with Mailsnappy.</p>
          </div>

          <div className="company-card">
            <img src={aiFallback} alt="Dreamville" />
            <p>Dreamville Records uses Mailsnappy to build their artists' brands and keep fans engaged.</p>
          </div>
        </div>

        <div className="company-row light-bg">
          <div className="stats">
            <p>On average, Mailsnappy users save over <strong>60%</strong> on the cost of their email marketing.</p>
            <p>Independent author Liz Gavin saves over <strong>$500</strong> per year since switching to Mailsnappy.</p>
          </div>
        </div>

        <div className="company-grid">
          <div className="company-card">
            <img src={aiFallback} alt="Level39" />
            <p>Startup hub Level39 relies on Mailsnappy to deliver critical updates to their members.</p>
          </div>

          <div className="company-card">
            <img src={aiFallback} alt="Zero to Marketing" />
            <p>Zero to Marketing uses Mailsnappy to send a weekly dose of startup inspiration to budding founders.</p>
          </div>
        </div>

        <div className="company-grid">
          <div className="company-card">
            <img src={aiFallback} alt="No Panic" />
            <p>No Panic supports people with anxiety disorders and saves money on their email marketing with Mailsnappy.</p>
          </div>

          <div className="company-card">
            <img src={aiFallback} alt="Liz Gavin" />
            <p>International bestselling author Liz Gavin grows her mailing list while saving money using Mailsnappy.</p>
          </div>
        </div>
      </section>

      <TestimonialSlider title="Customers choose Mailsnappy for simple, reliable email marketing" />

      <section className="ratings">
        <div className="ratings-left">
          <img src={aiFallback} alt="Five Stars" />
        </div>
        <div className="ratings-right">
          <h2>Rated five stars by our customers</h2>
          <p>Our customers love us and have shared hundreds of five-star reviews on trusted platforms.</p>
        </div>
      </section>

      <section className="cta-section">
        <h2>Start for free today</h2>
        <p>Sign up and send your first campaign in minutes. No credit card required.</p>
        <CTAButton className="primary-btn">Get started</CTAButton>
      </section>
    </div>
  );
};

export default Company;
